import { render, staticRenderFns } from "./StudyKeywordsSelect.vue?vue&type=template&id=39f09371&"
import script from "./StudyKeywordsSelect.vue?vue&type=script&lang=js&"
export * from "./StudyKeywordsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./StudyKeywordsSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports